/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantHealthSms
 */
export interface TenantHealthSms {
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSms
     */
    sent_7d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSms
     */
    failed_7d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSms
     */
    sent_30d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthSms
     */
    failed_30d?: number;
}

/**
 * Check if a given object implements the TenantHealthSms interface.
 */
export function instanceOfTenantHealthSms(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantHealthSmsFromJSON(json: any): TenantHealthSms {
    return TenantHealthSmsFromJSONTyped(json, false);
}

export function TenantHealthSmsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantHealthSms {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sent_7d': !exists(json, 'sent_7d') ? undefined : json['sent_7d'],
        'failed_7d': !exists(json, 'failed_7d') ? undefined : json['failed_7d'],
        'sent_30d': !exists(json, 'sent_30d') ? undefined : json['sent_30d'],
        'failed_30d': !exists(json, 'failed_30d') ? undefined : json['failed_30d'],
    };
}

export function TenantHealthSmsToJSON(value?: TenantHealthSms | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sent_7d': value.sent_7d,
        'failed_7d': value.failed_7d,
        'sent_30d': value.sent_30d,
        'failed_30d': value.failed_30d,
    };
}

